import React from 'react';
import { Link } from '@inertiajs/inertia-react';
import { BiLockAlt } from 'react-icons/bi';
import { AiOutlineCaretRight } from 'react-icons/ai';
import useHash from '../Shared/useHash';
// import { VisibilityContext } from "react-horizontal-scrolling-menu";

export default function ListItem({
  title,
  date,
  imageUrl,
  horizontal,
  sermonId,
  videoId,
  isHorizontalScroll,
  isLibraryItem,
  partNumber,
  itemIsLocked,
  itemId,
  description,
  link,
  mediaType,
  isActive,
  heading,
  videoDuration,
}) {
  const [hash, setHash] = useHash();

  // const visibility = React.useContext(VisibilityContext);
  // const visible = visibility.isItemVisible(itemId);

  // {/* no horizontal scrolling - default is list view on mobile, scroll menu on desktop

  // */}
  // if (!horizontal) {
  return (
    <div
      className={`w-full  mb-3`}>
      <Link
        href={itemIsLocked ? '#login' : link}
        onClick={itemIsLocked ? () => setHash('#login') : null}
        preserveState={itemIsLocked ? true : false}
        preserveScroll={itemIsLocked ? true : false}
        className={
          `rounded-none  card card-side  items-start ` +
          (isHorizontalScroll ? `md:rounded-none md:card md:mt-2 md:mb-3 !flex-col` : ``)+
          ` ${isActive ? 'bg-[#01BCD4] bg-opacity-40 p-2' : 'bg-base-100' }`
        }
      >
        {itemIsLocked && (
            <BiLockAlt className="absolute bottom-0 right-2" />
        )}
        {isActive && (
            <AiOutlineCaretRight className="self-center mr-2 fill-[#65BBC7]" />
        )}
        <div
          className={(isLibraryItem ? `w-24` : `w-32`) +
            ` flex-none ` +
            (isHorizontalScroll ? `!w-full` : ``)
          }
          
        >
            <div className={isLibraryItem ? `w-24 h-24 bg-center bg-cover bg-neutral rounded` 
            : `aspect-video-padding bg-center bg-cover bg-neutral rounded`} 
            style={{ backgroundImage: `url(${imageUrl})` }}>
              {videoDuration && (
                <div className='absolute bg-black/60 text-white font-bold text-sm p-2 rounded bottom-1 right-1 tracking-wider font-monospace'>
                  { videoDuration }
                </div>
              )}
            </div>
        </div>
        <div
          className={
            `card-body flex-auto p-2 pt-0 pb-0 gap-1 ` +
            (isHorizontalScroll ? `!p-0 !pt-2 ` : ``)
          }
        >
          {mediaType && (
              <p className={`text-xs tracking-wide uppercase text-left  mb-1 ${isActive ? 'text-white' : 'text-neutral-content'} `}>{mediaType}</p>
          )}

          {heading && (
            <h4 className="text-[#b6b6b6] text-xs font-semibold font-['Open Sans'] leading-3 tracking-tight uppercase" > {heading} </h4>
          )}

          <h2
            className={`text-base font-medium leading-5 line-clamp-2 md:line-clamp-2`}
          >
            {title}
          </h2>
          {sermonId && (
            <p className="text-xs text-left text-neutral-content">{sermonId}</p>
          )}
          {partNumber && (
            <p className="text-xs text-left text-neutral-content">{partNumber}</p>
          )}
          {description && (
            <p className="text-xs text-left text-neutral-content">
              {description}
            </p>
          )}
          {date && (
            <p className="text-xs text-left text-neutral-content">{date}</p>
          )}
        </div>
      </Link>
      {/* <div className={`col-12 mt-3 mb-3 border-b border-solid border-[#4F4F4F] ` + 
                    (desktopVertical ? `` : `md:hidden`)}></div> */}
    </div>
  );
  // {/* horizontal scrolling on Desktop & Mobile */}
  // } else {
  //     return (
  //         <div className="col-5 md:col-6 lg:col-3 mb-4">
  //             <Link href={"/on-demand/watch/" + videoId}
  //                 className="rounded-none card bg-base-100 shadow-xl items-start mt-2">
  //                 <div className="w-full flex-none pt-2 aspect-video-padding bg-center bg-cover"
  //                     style={{'backgroundImage': `url(${imageUrl})`}}>
  //                 </div>
  //                 <div className="card-body flex-auto p-0 pt-2 gap-1">
  //                     <h2 className="text-base font-semibold leading-5">{title}</h2>
  //                     {sermonId && (
  //                         <p className="text-xs text-left text-white">YoutubeEpisode #{sermonId}</p>
  //                     )}
  //                     {partNumber && (
  //                         <p className="text-xs text-left text-white">{partNumber}</p>
  //                     )}
  //                     <p className="text-[10px] text-left text-neutral-content">{date}</p>
  //                 </div>
  //             </Link>
  //         </div>
  //     )
  // }
}
